import { render } from "./EditSpda.vue?vue&type=template&id=8410980e"
import script from "./EditSpda.vue?vue&type=script&lang=js"
export * from "./EditSpda.vue?vue&type=script&lang=js"
script.render = render

export default script